import React from 'react';

// const DashboardPage = () => (
//   <div>
//     <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>
//     <p>Welcome, Admin! Here you can monitor all studio activity.</p>
//   </div>
// );
// export default DashboardPage;




import { useNavigate, useLocation } from "react-router-dom";

// const DashboardPage = () => {
//   const [currentUser] = useState({ name: "Admin User", role: "Administrator" });

//   const adminMenuItems = [
//     { name: "Dashboard", icon: "pi-home", path: "/dashboard" },
//     { name: "Members", icon: "pi-users", path: "/member" },
//     { name: "Attendance", icon: "pi-calendar-check", path: "/attendance" },
//     { name: "Reports", icon: "pi-chart-bar", path: "/report" },
//     { name: "Reminders", icon: "pi-bell", path: "/reminder" },
//     { name: "Settings", icon: "pi-cog", path: "/settings" }
//   ];

//   const quickStats = [
//     { title: "Total Members", value: "1,247", icon: "pi-users", color: "primary" },
//     { title: "Active Sessions", value: "23", icon: "pi-calendar", color: "success" },
//     { title: "Monthly Revenue", value: "$45,230", icon: "pi-dollar", color: "warning" },
//     { title: "Pending Payments", value: "12", icon: "pi-clock", color: "danger" }
//   ];







//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-100 py-8 px-2">
//       <div className="w-full max-w-5xl bg-white rounded-2xl shadow-2xl p-8 flex flex-col gap-8">
//         {/* Dashboard Header */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
//           <div>
//             <h1 className="text-3xl font-extrabold text-gray-800 mb-1 drop-shadow">Admin Dashboard</h1>
//             <p className="text-gray-600">Welcome back, {currentUser.name}</p>
//           </div>
//           <div className="flex flex-col items-end">
//             <span className="text-lg font-semibold text-blue-700">{currentUser.name}</span>
//             <span className="text-sm text-gray-500">{currentUser.role}</span>
//           </div>
//         </div>

//         {/* Quick Stats */}
//         <section>
//           <h2 className="text-xl font-bold text-blue-700 mb-4">Quick Overview</h2>
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {quickStats.map((stat, index) => (
//               <div key={index} className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex flex-col items-center shadow">
//                 <div className="text-3xl mb-2">
//                   <i className={`pi ${stat.icon} text-blue-600`}></i>
//                 </div>
//                 <h3 className="font-semibold text-blue-700 mb-1">{stat.title}</h3>
//                 <p className="text-2xl font-bold text-gray-800">{stat.value}</p>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* Recent Activity */}
//         <section>
//           <h2 className="text-xl font-bold text-blue-700 mb-4">Recent Activity</h2>
//           <div className="flex flex-col gap-4">
//             <div className="flex items-center gap-4 bg-gray-50 border border-gray-200 rounded-lg p-4 shadow">
//               <span className="text-2xl text-green-600"><i className="pi pi-user-plus"></i></span>
//               <div>
//                 <p className="text-gray-800">New member registered: John Doe</p>
//                 <span className="text-xs text-gray-500">2 hours ago</span>
//               </div>
//             </div>
//             <div className="flex items-center gap-4 bg-gray-50 border border-gray-200 rounded-lg p-4 shadow">
//               <span className="text-2xl text-blue-600"><i className="pi pi-credit-card"></i></span>
//               <div>
//                 <p className="text-gray-800">Payment received: $150.00</p>
//                 <span className="text-xs text-gray-500">4 hours ago</span>
//               </div>
//             </div>
//             <div className="flex items-center gap-4 bg-gray-50 border border-gray-200 rounded-lg p-4 shadow">
//               <span className="text-2xl text-purple-600"><i className="pi pi-calendar-check"></i></span>
//               <div>
//                 <p className="text-gray-800">Yoga class completed with 15 attendees</p>
//                 <span className="text-xs text-gray-500">6 hours ago</span>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );

//   // return (
//   //   <div className="dashboard-container">
//   //     {/* Dashboard Header */}
//   //     <div className="dashboard-header">
//   //       <div className="dashboard-title">
//   //         <h1>Admin Dashboard</h1>
//   //         <p>Welcome back, {currentUser.name}</p>
//   //       </div>
//   //       <div className="user-info">
//   //         <span className="user-name">{currentUser.name}</span>
//   //         <span className="user-role">{currentUser.role}</span>
//   //       </div>
//   //     </div>

//   //     {/* Quick Stats */}
//   //     <section className="stats-section">
//   //       <h2>Quick Overview</h2>
//   //       <div className="stats-grid">
//   //         {quickStats.map((stat, index) => (
//   //           <div key={index} className={`stat-card stat-${stat.color}`}>
//   //             <div className="stat-icon">
//   //               <i className={`pi ${stat.icon}`}></i>
//   //             </div>
//   //             <div className="stat-content">
//   //               <h3>{stat.title}</h3>
//   //               <p className="stat-value">{stat.value}</p>
//   //             </div>
//   //           </div>
//   //         ))}
//   //       </div>
//   //     </section>

//   //     {/* Recent Activity */}
//   //     <section className="recent-activity-section">
//   //       <h2>Recent Activity</h2>
//   //       <div className="activity-list">
//   //         <div className="activity-item">
//   //           <div className="activity-icon">
//   //             <i className="pi pi-user-plus"></i>
//   //           </div>
//   //           <div className="activity-content">
//   //             <p>New member registered: John Doe</p>
//   //             <span className="activity-time">2 hours ago</span>
//   //           </div>
//   //         </div>
//   //         <div className="activity-item">
//   //           <div className="activity-icon">
//   //             <i className="pi pi-credit-card"></i>
//   //           </div>
//   //           <div className="activity-content">
//   //             <p>Payment received: $150.00</p>
//   //             <span className="activity-time">4 hours ago</span>
//   //           </div>
//   //         </div>
//   //         <div className="activity-item">
//   //           <div className="activity-icon">
//   //             <i className="pi pi-calendar-check"></i>
//   //           </div>
//   //           <div className="activity-content">
//   //             <p>Yoga class completed with 15 attendees</p>
//   //             <span className="activity-time">6 hours ago</span>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     </section>
//   //   </div>
//   // );
// };

const tabList = [
  { key: 'fees-due', label: 'Fees Due' },
  { key: 'new-joiners', label: 'New Joiners' },
  { key: 'inactive-members', label: 'Inactive Members' },
];

const DashboardPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Get tab from URL query param, default to 'fees-due'
  const params = new URLSearchParams(location.search);
  const activeTab = params.get('tab') || 'fees-due';

  const setActiveTab = (tab) => {
    navigate(`?tab=${tab}`);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'fees-due':
        return (
          <div className="p-4">
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">Members with Fees Due</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Member ID</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Name</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Amount Due</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Due Date</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-2 px-4">M005</td>
                    <td className="py-2 px-4">Eve Adams</td>
                    <td className="py-2 px-4">$120.00</td>
                    <td className="py-2 px-4">2025-08-01</td>
                    <td className="py-2 px-4"><button className="text-blue-600 hover:underline">Remind</button></td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4">M010</td>
                    <td className="py-2 px-4">Frank Green</td>
                    <td className="py-2 px-4">$300.00</td>
                    <td className="py-2 px-4">2025-07-28</td>
                    <td className="py-2 px-4"><button className="text-blue-600 hover:underline">Remind</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'new-joiners':
        return (
          <div className="p-4">
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">New Joiners (Last 30 Days)</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Member ID</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Name</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Join Date</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Batch</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-2 px-4">M011</td>
                    <td className="py-2 px-4">Grace Hopper</td>
                    <td className="py-2 px-4">2025-07-20</td>
                    <td className="py-2 px-4">Hatha Morning</td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4">M012</td>
                    <td className="py-2 px-4">Harry Potter</td>
                    <td className="py-2 px-4">2025-07-25</td>
                    <td className="py-2 px-4">Vinyasa Evening</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'inactive-members':
        return (
          <div className="p-4">
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">Inactive Members (No attendance in last 60 days)</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Member ID</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Name</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Last Active</th>
                    <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-2 px-4">M004</td>
                    <td className="py-2 px-4">David Blue</td>
                    <td className="py-2 px-4">2025-05-10</td>
                    <td className="py-2 px-4"><button className="text-blue-600 hover:underline">Contact</button></td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4">M008</td>
                    <td className="py-2 px-4">Ivy Black</td>
                    <td className="py-2 px-4">2025-04-22</td>
                    <td className="py-2 px-4"><button className="text-blue-600 hover:underline">Contact</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-xl">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Admin Dashboard</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-indigo-50 p-6 rounded-lg shadow-md border border-indigo-200">
          <h3 className="text-2xl font-semibold text-indigo-700 mb-3">Total Members</h3>
          <p className="text-4xl font-bold text-indigo-900">1,250</p>
        </div>
        <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-200">
          <h3 className="text-2xl font-semibold text-green-700 mb-3">Active Trainers</h3>
          <p className="text-4xl font-bold text-green-900">15</p>
        </div>
        <div className="bg-purple-50 p-6 rounded-lg shadow-md border border-purple-200">
          <h3 className="text-2xl font-semibold text-purple-700 mb-3">Upcoming Classes Today</h3>
          <p className="text-4xl font-bold text-purple-900">8</p>
        </div>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabList.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200
                ${activeTab === tab.key
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-6">
        {renderTabContent()}
      </div>
    </div>
  );
};



export default DashboardPage; 